var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.0026 8.00016H12.0093M8.0026 8.00016H8.00927M4.0026 8.00016H4.00927M8.66927 8.00016C8.66927 8.36835 8.37079 8.66683 8.0026 8.66683C7.63441 8.66683 7.33594 8.36835 7.33594 8.00016C7.33594 7.63197 7.63441 7.3335 8.0026 7.3335C8.37079 7.3335 8.66927 7.63197 8.66927 8.00016ZM12.6693 8.00016C12.6693 8.36835 12.3708 8.66683 12.0026 8.66683C11.6344 8.66683 11.3359 8.36835 11.3359 8.00016C11.3359 7.63197 11.6344 7.3335 12.0026 7.3335C12.3708 7.3335 12.6693 7.63197 12.6693 8.00016ZM4.66927 8.00016C4.66927 8.36835 4.37079 8.66683 4.0026 8.66683C3.63441 8.66683 3.33594 8.36835 3.33594 8.00016C3.33594 7.63197 3.63441 7.3335 4.0026 7.3335C4.37079 7.3335 4.66927 7.63197 4.66927 8.00016Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.e1a72a8b98021d30f6d893cd869c5798.svg";
export { ForwardRef as ReactComponent };